import React, { useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Collapse,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import { AUDIT_CALLING_DETAILS_REPORT } from "../../constants";

function ConnectedCallTable({ callStatistics, filters, setFilters, setMetricData, setLoading }) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const location = useLocation();
  const { prevFilters } = location.state || {}; // Access prevFilters from state
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [totalCount, setTotalCount] = useState(0);
  const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded

  const { agentName, agentNo } = useParams();

  const [callData, setCallData] = useState([]);
  
  const isInitialLoad = useRef(true);

  const fetchConnectedData = () => {
    const { startDate, endDate } = filters;
  
    // Determine yesterday's date
    const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
  
    // Format startDate and endDate, defaulting to yesterday if not provided
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : yesterday;
    const formattedEndDate = endDate
      ? dayjs(endDate).format("YYYY-MM-DD")
      : yesterday;
  
    // Build query params
    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    if (localStorage.getItem("empRole") === "100") {
      queryParams.append("agentNumber", empDetails.EmployeePhone);
    }else{
      queryParams.append("agentNumber", agentNo);
    }
    queryParams.append("callStatus", "Connected");
    queryParams.append("page", page + 1); // Current page (1-based index)
    queryParams.append("pageSize", rowsPerPage); // Number of rows per page
    setLoading(true);
    axios
      .get(`${AUDIT_CALLING_DETAILS_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        const { calls, pagination, summary } = response.data;
        
        setCallData(calls); // Update the call data
        setTotalCount(pagination.totalRecords); // Update the total record count
        setMetricData(summary);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching connected data:", error);
        setCallData([]); // Set call data to empty on error
        setLoading(false);
      });
  };
  


  // Initialize filters with prevFilters
  useEffect(() => {
    if(localStorage.getItem("empRole") === "101"){
    if (prevFilters) {
      console.log("Applying prevFilters:", prevFilters);
      setFilters(prevFilters);
    } else {
      // Default to the last 7 days
      setFilters({
        startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
      });
    }
    isInitialLoad.current = false; // Mark initial load as complete
    }
  }, [prevFilters]);

  // Fetch data when filters, page, or rowsPerPage change
  useEffect(() => {
    if(localStorage.getItem("empRole") === "101"){
    if (isInitialLoad.current || !filters.startDate || !filters.endDate) {
      return; // Skip if it's the initial load or filters are incomplete
    }
    console.log("Fetching data with filters:", filters);
    fetchConnectedData();
  }
  }, [filters, page, rowsPerPage]);

    useEffect(() => {
      if(localStorage.getItem("empRole") === "100"){
      fetchConnectedData();
      }
    }, [filters, page, rowsPerPage]);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  // Handle row expansion toggle
  const handleRowToggle = (index) => {
    setOpenRows((prev) => {
      if (prev.includes(index)) {
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const formatDate = (dateString) =>
    moment(dateString).format("DD-MM-YYYY HH:mm:ss");

  return (
    <>
      <Paper>
        <TableContainer component={Paper} elevation={3}>
          <Table
            sx={{
              minWidth: 650,
              height: "100%",
              tableLayout: "fixed",
            }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                <TableCell width={50} sx={{ textAlign: "center" }} />
                <TableCell
                  width={50}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  SNo
                </TableCell>
                
                <TableCell
                  width={150}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Mobile Number
                </TableCell>
                <TableCell
                  width={150}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Start Time
                </TableCell>
                <TableCell
                  width={120}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  End Time
                </TableCell>
                <TableCell
                  width={120}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Duration (Minutes)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(callData) && callData.length > 0 ? (
                callData
                  .map((row, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                      <TableRow
                        sx={{
                          "&:hover": { backgroundColor: "#f9f9f9" },
                        }}
                      >
                        <TableCell>
                          <IconButton
                            onClick={() => handleRowToggle(rowIndex)}
                            sx={{ padding: 0 }}
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell width={50} sx={{ textAlign: "center" }}>
                          {page * rowsPerPage + rowIndex + 1}
                        </TableCell>
                        {/* <TableCell width={160} sx={{ textAlign: "center" }}>
                          {row.customer_details === null
                            ? "New Customer"
                            : row.customer_details?.farmer_name}
                        </TableCell> */}
                        <TableCell width={150} sx={{ textAlign: "center" }}>
                          {row.callerNumber || "-"}
                        </TableCell>
                        <TableCell width={150} sx={{ textAlign: "center" }}>
                          {row.callStartTime === null ? "-" : formatDate(row.callStartTime)}
                        </TableCell>
                        <TableCell width={120} sx={{ textAlign: "center" }}>
                          {row.callEndTime === null ? "-" : formatDate(row.callEndTime)}
                        </TableCell>
                        <TableCell
                          width={120}
                          sx={{
                            textAlign: "center",
                            textTransform: "capitalize",
                          }}
                        >
                          {row.duration || "-"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          sx={{ paddingBottom: 0, paddingTop: 0 }}
                        >
                          <Collapse
                            in={openRows.includes(rowIndex)}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Paper sx={{ padding: 2 }}>
                              <Typography variant="h6">
                                Customer Details
                              </Typography>
                              <Typography>
                                <strong>Farmer Name:</strong>{" "}
                                {row.customer_details?.farmer_name || "-"}
                              </Typography>
                              <Typography>
                                <strong>Lot Number:</strong>{" "}
                                {row.customer_details?.lot_number || "-"}
                              </Typography>
                              <Typography>
                                <strong>Zone:</strong>{" "}
                                {row.customer_details?.zone || "-"}
                              </Typography>
                              <Typography>
                                <strong>Branch:</strong>{" "}
                                {row.customer_details?.branch || "-"}
                              </Typography>
                              <Typography>
                                <strong>Hatch Date:</strong>{" "}
                                {row.customer_details?.hatch_date || "-"}
                              </Typography>
                              <Typography>
                                <strong>Placed Quantity:</strong>{" "}
                                {row.customer_details?.placed_qty || "-"}
                              </Typography>
                              <Typography>
                                <strong>Shed Type:</strong>{" "}
                                {row.customer_details?.shed_type || "-"}
                              </Typography>
                              <Typography>
                                <strong>Status:</strong>{" "}
                                {row.customer_details?.status || "-"}
                              </Typography>
                              <Typography>
                                <strong>Vendor:</strong>{" "}
                                {row.customer_details?.vendor || "-"}
                              </Typography>
                              <Typography>
                                <strong>Total Mortality:</strong>{" "}
                                {row.customer_details?.total_mortality || "-"}
                              </Typography>
                              <Typography>
                                <strong>Mortality Percentage:</strong>{" "}
                                {row.customer_details?.mortality_percentage ||
                                  "-"}
                              </Typography>
                            </Paper>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No details yet
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]} // Options for rows per page
          component="div"
          count={totalCount} // Total number of rows
          rowsPerPage={rowsPerPage} // Current rows per page
          page={page} // Current page
          onPageChange={handleChangePage} // Handle page change
          onRowsPerPageChange={handleChangeRowsPerPage} // Handle rows per page change
        />
      </Paper>
    </>
  );
}

export default ConnectedCallTable;
